import {
    Card,
    Select,
    Button,
    Loading,
    HintList,
    Label,
    Textarea,
} from "components"
import moment from "moment"
import { useForm, Controller, useFormContext, useWatch, FormProvider } from "react-hook-form"
import { FormStateProjectProfile } from "../types/ProfileTypes"
import { yupResolver } from "@hookform/resolvers/yup"
import { useEffect, useState } from "react"

import toast from "react-hot-toast"
import { useApi } from "utils"

import { useProfileDetail } from "../utils/useProfileDetail"
import { FormAddressProject } from "../types/AdressTypes"
import { addressProjectSchema } from "../validation/AddressProjectSchema"
import { useCountry, useProvince, useRegency, useSubdistrict, useVillage } from "pages/Setup/Preference/Project/components/FormSection/utils"
import { useProjectAddress } from "../utils/useProjectAddress"

interface TabProps{
    action?:string
    project_id?:string
    approval_view?:boolean
    data_profile?:FormStateProjectProfile
}
export function TabAddress(props:TabProps): JSX.Element {
    const isDisabledForm = Boolean(props.action === 'view')
    const api = useApi()
    const [isLoading , setLoading] = useState(true)
    const { data } = useProfileDetail(props.project_id)
    const { data:address , refetch:refetchAddress} = useProjectAddress(Number(props.project_id))
    // const { data:dataDashboard, isLoading:loadingDashboard } = useDashboardList(Number(props.project_id))
    const [dataProfile, setDataProfile] = useState<FormStateProjectProfile | null>(null);
    // const [dataAddress, setDataAddress] = useState<FormAddressProject | null>(null);
    const [dayBehind,setDayBehind ] = useState(0)
    const [weekBehind,setWeekBehind ] = useState(0)

    const methods = useForm<FormAddressProject>({
        resolver: yupResolver(addressProjectSchema),
        defaultValues: {
            project_name: '',
            country_id: '',
            province_id: '',
            regency_id: '',
            subdistrict_id: '',
            village_id: '',
            address: '',
            note: null
        },
    });

    const { handleSubmit, control, setValue } = methods;

    useEffect(() => {
        if (isLoading && ((!data || data.length === 0) || !address)) return;

        setDataProfile(data[0])
        // setDataAddress(address ?? null)
        const startDate = data[0].start_date;
        const dueDate = data[0].due_date;
        const today = moment().toDate()
        // Hitung durasi (hari)
        const dayBehind = startDate ? moment(dueDate).diff(moment(today), "days") : 0;
        let weekBehind =  startDate ? moment(today).diff(moment(startDate), "days") : 0;
        weekBehind = Math.ceil(weekBehind / 7 );
        
        setDayBehind(dayBehind)
        setWeekBehind(weekBehind)
        setLoading(false)

        if(address){
            Object.entries(address).forEach(([key, value]) => {
                if (value !== undefined) {
                    setValue(key as keyof FormAddressProject, value);
                }
            });
        }
       
        // eslint-disable-next-line
    },[data, address])


    const onSubmit = async (value: FormAddressProject) => {
        await toast
        .promise(api.put(`/project/edit?project_id=${dataProfile?.project_id}`, value), {
            loading: "Loading...",
            success: (res) => {
                console.log(res.data);
                return res.data.message
            },
            error: (err) => err.response.data.detail?.message ?? err.response.data.message
        })
        .then(() => {
            refetchAddress()
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        })
        .catch((err) => {
            throw new Error(err);
        });
    };


    // handle semua error
    const onError = (errors: any) => {
        Object.values(errors).forEach((error: any) => {
            if (error?.message) {
                toast.error(error.message)
            } else if (typeof error === 'object') {
                Object.values(error).forEach((subError: any) => {
                    if (subError?.message) toast.error(subError.message)
                })
            }
        })
    };

    if(isLoading) return (
        <Loading
        loading={isLoading}
        errorText="No data available"
      />
    )

    return (
        <section className="">
            <section>
            <Card>
                    <Card.Body>
                      
                        <div className="flex flex-row w-full"> 
                            <div className="grow">
                                <div className="text-2xl font-bold uppercase py-4">
                                    {dataProfile?.project_name}
                                </div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>START DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.start_date) ? moment(dataProfile.start_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>DUE DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.due_date) ? moment(dataProfile.due_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="flex gap-2">
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">DURATION | DAYS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{dayBehind}</span>
                                        <span className="text-sm">Leaf of days</span>
                                    </section>
                                </div>
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">START | WEEKS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{weekBehind}</span>
                                        <span className="text-sm">Weeks</span>
                                    </section>
                                </div>
                            </div>
                        </div>
                 
                    </Card.Body>
                </Card>
            </section>

        
            <section className="">
                <Card>
                    <Card.Body>
                        <div className="flex lg:grid-cols-2 gap-[50px] justify-between">
                            <div className="w-full">
                                <table className="table">
                                    <tbody>
                                        <FormProvider {...methods}>
                                            <Country isDisabled={Boolean(isDisabledForm)} />
                                            <Province isDisabled={Boolean(isDisabledForm)} />
                                            <Regency isDisabled={Boolean(isDisabledForm)} />
                                            <Subdistrict isDisabled={Boolean(isDisabledForm)} />
                                            <Village isDisabled={Boolean(isDisabledForm)} />
                                        </FormProvider>
                                        <Controller
                                            control={control}
                                            name="address"
                                            render={({ field, fieldState }) => 
                                                <tr>
                                                    <td><Label text="ADDRESS" error={Boolean(fieldState.error)} /></td>
                                                    <td><Textarea {...field} placeholder="Input Address" value={field.value ?? ""} disabled={isDisabledForm} error={fieldState.error?.message} /></td>
                                                </tr>
                                            }
                                        />
                                        <Controller
                                            control={control}
                                            name="note"
                                            render={({ field, fieldState }) => 
                                                <tr>
                                                    <td><Label text="NOTE" /></td>
                                                    <td><Textarea {...field} placeholder="Input Note" value={field.value ?? ""} disabled={isDisabledForm} error={fieldState.error?.message} /></td>
                                                </tr>
                                            }
                                        />
                                    </tbody>
                                </table>
                                <div className="flex justify-end mt-[30px] mb-[30px]">
                                    <Button color="primary" 
                                        disabled={isDisabledForm}
                                        className="min-w-[100px]"
                                        type="button"
                                        permission="ST19"
                                        onClick={handleSubmit(onSubmit, onError)}
                                    >
                                        SAVE
                                    </Button>
                                </div>
                            </div>
                            <div className="w-full">
                                <HintList
                                    title="Project Address"
                                    list={[
                                        
                                        {
                                        label: "Country",
                                        list: [
                                            {
                                            label: "Definition",
                                            value: "The country where the project is being executed."
                                            },
                                            {
                                            label: "Purpose",
                                            value: "Helps in categorizing and managing projects based on their geographical location."
                                            },
                                            {
                                            label: "Options",
                                            value: "Select from a list of countries."
                                            },
                                        ]
                                        },
                                        {
                                        label: "Province",
                                        list: [
                                            {
                                            label: "Definition",
                                            value: "The province or state within the country where the project is based."
                                            },
                                            {
                                            label: "Purpose",
                                            value: "Provides more specific geographical information within the country."
                                            },
                                            {
                                            label: "Options",
                                            value: "Select from a list of provinces or states."
                                            },
                                        ]
                                        },
                                        {
                                        label: "Regency",
                                        list: [
                                            {
                                            label: "Definition",
                                            value: "The regency or district within the province where the project is situated."
                                            },
                                            {
                                            label: "Purpose",
                                            value: "Further refines the location details for better project management."
                                            },
                                            {
                                            label: "Options",
                                            value: "Select from a list of regencies or districts."
                                            },
                                        ]
                                        },
                                        {
                                        label: "Subdistrict",
                                        list: [
                                            {
                                            label: "Definition",
                                            value: "The subdistrict or smaller administrative unit within the regency."
                                            },
                                            {
                                            label: "Purpose",
                                            value: "Provides additional granularity for location details."
                                            },
                                            {
                                            label: "Options",
                                            value: "Select from a list of subdistricts."
                                            },
                                        ]
                                        },
                                        {
                                        label: "Village",
                                        list: [
                                            {
                                            label: "Definition",
                                            value: "The village or neighborhood where the project is located."
                                            },
                                            {
                                            label: "Purpose",
                                            value: "Offers the most precise location information."
                                            },
                                            {
                                            label: "Options",
                                            value: "Select from a list of villages or neighborhoods."
                                            },
                                        ]
                                        },
                                        {
                                        label: "Full Address",
                                        list: [
                                            {
                                            label: "Definition",
                                            value: "The complete address for the project, including street number and name."
                                            },
                                            {
                                            label: "Purpose",
                                            value: "Ensures accurate location details for logistics, correspondence, and operations."
                                            },
                                            {
                                            label: "Example",
                                            value: "456 Elm Street, Building 789."
                                            },
                                        ]
                                        },
                                        {
                                        label: "Note",
                                        list: [
                                            {
                                            label: "Definition",
                                            value: "Any additional information or remarks about the project."
                                            },
                                            {
                                            label: "Purpose",
                                            value: "Provides context or special instructions relevant to the project."
                                            },
                                            {
                                            label: "Example",
                                            value: "Construction starts in June, Marketing team contact: Jane Doe."
                                            },
                                        ]
                                        }
                                    ]}
                                />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                
            </section>
        </section>
    )
}

function Country(props: { isDisabled: boolean }) {
    const { control } = useFormContext<FormAddressProject>()
    const { data, isLoading } = useCountry()

    return (
    <Controller
        control={control}
        name="country_id"
        render={({ field, fieldState }) => (
        <tr>
            <td>
            <Label
                text="COUNTRY"
                error={Boolean(fieldState.error)}
            />
            </td>
            <td>
            <Select
                placeholder="Choose country"
                isDisabled={props.isDisabled}
                isLoading={isLoading}
                error={fieldState.error?.message}
                options={data}
                value={data.find(item => item.value?.toString() === field.value?.toString())}
                onChange={e => field.onChange(e?.value)}
            />
            </td>
        </tr>
        )}
    />
    )
}
function Province(props: { isDisabled: boolean }) {
    const { control } = useFormContext<FormAddressProject>()
    const country_id = useWatch({ control, name: "country_id" })
    const { data, isLoading, refetch } = useProvince()

    useEffect(() => {
    if(country_id) { refetch(country_id?.toString()) }
    // eslint-disable-next-line
    }, [country_id])

    return (
    <Controller
        control={control}
        name="province_id"
        render={({ field, fieldState }) => (
        <tr>
            <td>
            <Label
                text="PROVINCE"
                error={Boolean(fieldState.error)}
            />
            </td>
            <td>
            <Select
                placeholder="Choose province"
                isDisabled={props.isDisabled}
                isLoading={isLoading}
                error={fieldState.error?.message}
                options={data}
                value={data.find(item => item.value?.toString() === field.value?.toString())}
                onChange={e => field.onChange(e?.value)}
            />
            </td>
        </tr>
        )}
    />
    )
}
function Regency(props: { isDisabled: boolean }) {
    const { control } = useFormContext<FormAddressProject>()
    const province_id = useWatch({ control, name: "province_id" })
    const { data, isLoading, refetch } = useRegency()

    useEffect(() => {
    if(province_id) { refetch(province_id?.toString()) }
    // eslint-disable-next-line
    }, [province_id])

    return (
    <Controller
        control={control}
        name="regency_id"
        render={({ field, fieldState }) => (
        <tr>
            <td>
            <Label
                text="REGENCY"
                error={Boolean(fieldState.error)}
            />
            </td>
            <td>
            <Select
                placeholder="Choose regency"
                isDisabled={props.isDisabled}
                isLoading={isLoading}
                error={fieldState.error?.message}
                options={data}
                value={data.find(item => item.value?.toString() === field.value?.toString())}
                onChange={e => field.onChange(e?.value)}
            />
            </td>
        </tr>
        )}
    />
    )
}
function Subdistrict(props: { isDisabled: boolean }) {
    const { control } = useFormContext<FormAddressProject>()
    const regency_id = useWatch({ control, name: "regency_id" })
    const { data, isLoading, refetch } = useSubdistrict()

    useEffect(() => {
    if(regency_id) { refetch(regency_id?.toString()) }
    // eslint-disable-next-line
    }, [regency_id])

    return (
    <Controller
        control={control}
        name="subdistrict_id"
        render={({ field, fieldState }) => (
        <tr>
            <td>
            <Label
                text="SUBDISTRICT"
                error={Boolean(fieldState.error)}
            />
            </td>
            <td>
            <Select
                placeholder="Choose subdistric"
                isDisabled={props.isDisabled}
                isLoading={isLoading}
                error={fieldState.error?.message}
                options={data}
                value={data.find(item => item.value?.toString() === field.value?.toString())}
                onChange={e => field.onChange(e?.value)}
            />
            </td>
        </tr>
        )}
    />
    )
}
function Village(props: { isDisabled: boolean }) {
    const { control } = useFormContext<FormAddressProject>()
    const subdistrict_id = useWatch({ control, name: "subdistrict_id" })
    const { data, isLoading, refetch } = useVillage()

    useEffect(() => {
    if(subdistrict_id) { refetch(subdistrict_id?.toString()) }
    // eslint-disable-next-line
    }, [subdistrict_id])

    return (
    <Controller
        control={control}
        name="village_id"
        render={({ field, fieldState }) => (
        <tr>
            <td>
            <Label
                text="VILLAGE"
                error={Boolean(fieldState.error)}
            />
            </td>
            <td>
            <Select
                placeholder="Choose village"
                isDisabled={props.isDisabled}
                isLoading={isLoading}
                error={fieldState.error?.message}
                options={data}
                value={data.find(item => item.value?.toString() === field.value?.toString())}
                onChange={e => field.onChange(e?.value)}
            />
            </td>
        </tr>
        )}
    />
    )
}
